import { logout } from "@store/reducers/auth";
import axios, { Method } from "axios";
import Cookies from "js-cookie";
import router from "next/router";
import { isEmpty } from "src/lib/index";
import { makeStore } from "store";
import { toast } from "react-toastify";

const client = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL
});

client.defaults.timeout = 20000;
client.interceptors.response.use(
  (config) => config,
  (error: any) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      // toast.error('An unexpected error occurrred.');
      console.error(error);
    }
    if (error?.response?.status === 401) {
      makeStore().dispatch(logout(""));
      router.push("/auth");
    }
    return Promise.reject(error);
  }
);
const errorComposer = (err: any) => {
  if (err?.data?.message === "Error Occurred!!!") {
    toast.error("متاسفانه مشکلی پیش آمد، لطفا دوباره تلاش نمایید.");
    return true;
  }
  return false;

};
const call = async <T>(
  method: Method,
  url: string,
  data: any = {},
  header: any = {}
): Promise<T> => {
  const accessToken = Cookies.get("access_token");

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-clientid": "d6be0366-c762-4f2b-a2b3-43c9a308f3e2",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
    ...header
  };

  if (accessToken) {
    client.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  }

  const request: any = { headers, method, url };

  if (!isEmpty(data)) {
    if (method === "get") {
      request.params = data;
    } else {
      request.data = data;
    }
  }

  try {
    const response = await client(request);
    return Promise.resolve(response.data);
  } catch (error: any) {
    let err = null;
    if (error.response) {
      err = error.response;
    } else if (error.request) {
      err = { message: error.request._response };
    } else {
      err = error;
    }
    err.handleGlobally = errorComposer(err);
    return Promise.reject(err);
  }
};

const file = async (
  url: string,
  data: FormData,
  onUploadProgress?: ((progressEvent: any) => void) | undefined
) => {
  try {
    const headers = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data"
    };
    const response = await client({
      url,
      data,
      method: "post",
      headers,
      onUploadProgress
    });

    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

export default {
  delete: <T, D = any>(url: string, data?: D | null) =>
    call<T>("delete", url, data),
  get: <T, D = any>(url: string, data?: D | null, header?: D | null) =>
    call<T>("get", url, data, header),
  patch: <T, D = any>(url: string, data?: D | null) =>
    call<T>("patch", url, data),
  post: <T, D = any>(url: string, data?: D | null, header?: D | null) =>
    call<T>("post", url, data, header),
  put: <T, D = any>(url: string, data?: D | null) => call<T>("put", url, data),
  file: (
    url: string,
    data: FormData,
    onUploadProgress: ((progressEvent: any) => void) | undefined
  ) => file(url, data, onUploadProgress)
};
